import { Lock } from "lucide-react";
import { cn } from "@/lib/utils";

export function ImmutableBadge({ className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-medium",
        "bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-sm",
        className
      )}
      title="Immutable, hash-chained evidence record"
    >
      <Lock className="w-3 h-3" strokeWidth={2.5} />
      Immutable
    </span>
  );
}
